// Client helpers for personalized listing URLs (/<coach>/<listing>).
// The server owns the mapping — see server/vanityUrls.js.

const pathCache = new Map();

const getJson = url =>
  fetch(url, { credentials: 'same-origin' }).then(res => {
    if (res.status === 404) return null;
    if (!res.ok) throw new Error(`${url} failed with ${res.status}`);
    return res.json();
  });

/** Resolves to "/coach/listing" for a published listing, or null. */
export const fetchVanityPath = listingId => {
  if (!listingId) return Promise.resolve(null);
  if (!pathCache.has(listingId)) {
    const request = getJson(`/api/vanity/path?id=${encodeURIComponent(listingId)}`)
      .then(body => (body && body.path) || null)
      .catch(() => {
        // Don't cache failures (e.g. dev server without the Express API).
        pathCache.delete(listingId);
        return null;
      });
    pathCache.set(listingId, request);
  }
  return pathCache.get(listingId);
};

/** Resolves a personalized URL to a listing id, or null if unknown. */
export const resolveVanityPath = (coach, listing) =>
  getJson(
    `/api/vanity/resolve?coach=${encodeURIComponent(coach)}&listing=${encodeURIComponent(listing)}`
  ).then(body => (body && body.id) || null);

// Exposed for tests.
export const clearVanityPathCache = () => pathCache.clear();
